import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-vehicle-driver',
  templateUrl: './manage-vehicle-driver.component.html',
  styleUrls: ['./manage-vehicle-driver.component.css']
})
export class ManageVehicleDriverComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
